import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./css/Lottery.css";

class Lottery extends Component {

    state = {
        isCodesModal: false,      // Modal لیست کدها
        isJoinModal: false,       // Modal تأیید شرکت
        selectedLottery: null,    // طرح انتخاب‌شده برای شرکت
        codesFilterLotteryId: null, // ← جدید: اگر پر باشد، Modal فیلترشده باز می‌شود
    };

    openAllCodesModal = () => {
        this.setState({
            isCodesModal: true,
            codesFilterLotteryId: null,
        });
    };

    openLotteryCodesModal = (lotteryId) => {
        this.setState({
            isCodesModal: true,
            codesFilterLotteryId: lotteryId,
        });
    };

    closeCodesModal = () => {
        this.setState({
            isCodesModal: false,
            codesFilterLotteryId: null,
        });
    };


    getCodesForLottery = (lotteryId) => {
        return this.props.codes.filter(c => c.lotteryId === lotteryId);
    };
    getDisplayedCodes = () => {
        const { codesFilterLotteryId } = this.state;
        if (codesFilterLotteryId === null) {
            return this.props.codes;
        }
        return this.getCodesForLottery(codesFilterLotteryId);
    };
    getCodesModalTitle = () => {
        const { codesFilterLotteryId } = this.state;
        if (codesFilterLotteryId === null) {
            return "کدهای قرعه‌کشی من";
        }
        const lottery = this.props.lotteries.find(l => l.id === codesFilterLotteryId);
        return lottery ? `کدهای ${lottery.title}` : "کدهای من";
    };



    toggleJoinModal = (lottery = null) => {
        this.setState({
            isJoinModal: !this.state.isJoinModal,
            selectedLottery: lottery,
        });
    };

    // ==== تأیید نهایی و ارسال به parent ====
    handleConfirmJoin = () => {
        const { selectedLottery } = this.state;
        if (!selectedLottery) return;

        this.props.onJoinLottery(selectedLottery.id, selectedLottery.coinCost);
        this.toggleJoinModal();
    };

    // ==== بررسی فعال بودن دکمه ====
    isLotteryAvailable = (lottery) => {
        return this.props.coins >= lottery.coinCost;
    };

    render() {
        const { coins, codes, loading, onBack, lotteries } = this.props;
        const { isCodesModal, isJoinModal, selectedLottery } = this.state;

        if (!lotteries || lotteries.length === 0) {
            return (
                <div className="lottery-page body-padding">
                    <div className="lottery-back-bar">
                        <button className="lottery-back-btn" onClick={onBack}>
                            ← بازگشت
                        </button>
                    </div>

                    <div className="text-center py-5">
                        <p className="text-muted">در حال بارگذاری طرح‌های قرعه‌کشی...</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="lottery-page body-padding">

                <div className="lottery-back-bar">
                    <button className="lottery-back-btn" onClick={onBack}>
                        ← بازگشت
                    </button>
                </div>
                <div className="lottery-top-boxes">
                    <div className="coin-box">
                        <div className="coin-box-icon"><span role="img" aria-label="description">🪙</span></div>
                        <div className="coin-box-info">
                            <span className="coin-box-label">موجودی سکه</span>
                            <span className="coin-box-value">{coins}</span>
                        </div>
                    </div>
                    <div
                        className="codes-box"
                        onClick={this.openAllCodesModal}
                        role="button"
                    >
                        <div className="codes-box-icon"><span aria-label="description" role="img">🎟️</span></div>
                        <div className="codes-box-info">
                            <span className="codes-box-label">کدهای من</span>
                            <span className="codes-box-value">{codes.length}</span>
                        </div>
                    </div>
                </div>
                <div className="lottery-cards">
                    {lotteries.map((lottery) => {
                        const available = this.isLotteryAvailable(lottery);
                        return (
                            <div key={lottery.id} className="lottery-card">

                                <div className="lottery-card-image">
                                    <img src={lottery.imageUrl} alt={lottery.title} />
                                </div>
                                <div className="lottery-card-body">
                                    <h4 className="lottery-card-title">{lottery.title}</h4>

                                    <div className="lottery-card-meta">
                                        <div className="lottery-meta-row">
                                            <span className="meta-label">شروع:</span>
                                            <span className="meta-value">{lottery.startDate}</span>
                                        </div>
                                        <div className="lottery-meta-row">
                                            <span className="meta-label">پایان:</span>
                                            <span className="meta-value">{lottery.endDate}</span>
                                        </div>
                                        <div className="lottery-meta-row">
                                            <span className="meta-label">شرایط:</span>
                                            <span className="meta-value">{lottery.conditions}</span>
                                        </div>
                                        <div className="lottery-meta-row">
                                            <span className="meta-label">هزینه:</span>
                                            <span className="meta-value coin-cost">
                                                {lottery.coinCost} سکه
                                            </span>
                                        </div>
                                    </div>
                                    <button
                                        className={`lottery-btn ${available ? "active" : "disabled"}`}
                                        disabled={!available || loading}
                                        onClick={() => this.toggleJoinModal(lottery)}
                                    >
                                        {available
                                            ? "دریافت کد قرعه‌کشی"
                                            : `${lottery.coinCost} سکه نیاز است`}
                                    </button>
                                    <button
                                        className="lottery-codes-btn"
                                        onClick={() => this.openLotteryCodesModal(lottery.id)}
                                    >
                                        <span role="img" aria-label="description">🎟️</span> مشاهده کدهای من
                                        {this.getCodesForLottery(lottery.id).length > 0 && (
                                            <span className="lottery-codes-badge">
                                                {this.getCodesForLottery(lottery.id).length}
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <Modal show={isCodesModal} onHide={this.closeCodesModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.getCodesModalTitle()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.getDisplayedCodes().length === 0 ? (
                            <p className="text-center text-muted m-0">
                                هنوز کدی برای این طرح دریافت نکرده‌اید.
                            </p>
                        ) : (
                            <div className="codes-list">
                                {this.getDisplayedCodes().map((item, index) => (
                                    <div key={item.id || index} className="code-item">
                                        <span className="code-value">{item.code}</span>
                                        <span className="code-title">
                                            {item.lotteryTitle || "-"}
                                        </span>
                                        <span className="code-date">{item.issuedAt || "-"}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn btn-sm dina-btn-orange"
                            onClick={this.closeCodesModal}
                        >
                            بستن
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* ==== Modal تأیید شرکت در قرعه‌کشی ==== */}
                <Modal show={isJoinModal} onHide={() => this.toggleJoinModal()} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>تأیید دریافت کد</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedLottery && (
                            <>
                                <p className="mb-3 text-justify">
                                    با تأیید این درخواست، مبلغ{" "}
                                    <strong>{selectedLottery.coinCost} سکه</strong> از موجودی
                                    شما کسر می‌شود و یک کد قرعه‌کشی برای طرح{" "}
                                    <strong>{selectedLottery.title}</strong> صادر می‌گردد.
                                </p>

                                <div className="confirm-details">
                                    <div className="confirm-row">
                                        <span>موجودی فعلی:</span>
                                        <strong>{coins} سکه</strong>
                                    </div>
                                    <div className="confirm-row">
                                        <span>هزینه طرح:</span>
                                        <strong>{selectedLottery.coinCost} سکه</strong>
                                    </div>
                                    <div className="confirm-row highlight">
                                        <span>موجودی باقیمانده:</span>
                                        <strong>
                                            {coins - selectedLottery.coinCost} سکه
                                        </strong>
                                    </div>
                                </div>

                                <p className="mt-3 mb-0 text-muted small text-justify">
                                    آیا از انجام این عملیات اطمینان دارید؟
                                </p>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn btn-sm btn-secondary"
                            onClick={() => this.toggleJoinModal()}
                        >
                            انصراف
                        </Button>
                        <Button
                            className="btn btn-sm dina-btn-orange"
                            onClick={this.handleConfirmJoin}
                            disabled={loading}
                        >
                            {loading ? "در حال ارسال..." : "تأیید نهایی و دریافت کد"}
                        </Button>
                    </Modal.Footer>
                </Modal>

            </div>
        );
    }
}

export default Lottery;